import { requestAndParse, requestSuccessful } from '../request';

const disconnectAccount = async (userId: number, teacherId: number) => {
    const route = 'admin/disconnect-account';
    const payload = {
        userId,
        teacherId,
    };

    const response = await requestAndParse(route, payload, 'DELETE');

    const success = requestSuccessful(response);
    const message = response.body?.message as string;

    return { success, message };
};

export default disconnectAccount;
